import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "col-span-6" }
const _hoisted_2 = { class: "lg:max-w-screen-md 2xl:max-w-screen-2xl pr-2 lg:mr-6" }
const _hoisted_3 = {
  key: 0,
  class: "2xl:pt-4 mt-2 flex justify-end"
}
const _hoisted_4 = ["href"]

import { ArrowDownTrayIcon } from "@heroicons/vue/24/solid";
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { useCurrentCustomerName, useCurrentSiteId } from "shared/composables/project";
import { useTrackEvent } from "shared/composables/tracking";
import logger from "shared/services/logger";
import Sidebar from "@/components/layout/Sidebar.vue";
import OculaiVideoPlayer from "@/components/other/OculaiVideoPlayer.vue";
import CameraRepository from "@/repositories/CameraRepository";
import CameraItemLayout from "@/views/camera/components/CameraItemLayout.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectTimelapse',
  setup(__props) {

const currentCustomerName = useCurrentCustomerName();
const currentSiteId = useCurrentSiteId();
const { params } = useRoute();

const timelapseUrl = ref("");
const loading = ref(false);
const noData = ref(false);

const trackEvent = useTrackEvent();

const getTimelapseUrl = () => {
  loading.value = true;

  return CameraRepository.loadProjectTimelapse(
    currentCustomerName,
    currentSiteId,
    params?.camera_id as string,
  )
    .then((data) => {
      if (data) {
        timelapseUrl.value = data?.presigned_url_timelapse;
      } else {
        noData.value = true;
      }
    })
    .catch((error) => {
      timelapseUrl.value = "";
      logger.error(error);
    })
    .finally(() => {
      loading.value = false;
    });
};

onMounted(() => {
  trackEvent("camera_project-timelapse_view");
  getTimelapseUrl();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Sidebar, null, {
    default: _withCtx(() => [
      _createVNode(CameraItemLayout, { noData: noData.value }, {
        contentLeft: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(OculaiVideoPlayer, {
                loading: loading.value,
                src: timelapseUrl.value,
                noSrcMessage: _ctx.$t('err.no_data_yet')
              }, null, 8, ["loading", "src", "noSrcMessage"]),
              (!loading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(trackEvent)('camera_project-timelapse_download_click')))
                    }, [
                      _createElementVNode("a", { href: timelapseUrl.value }, [
                        _createVNode(_unref(ArrowDownTrayIcon), { class: "h-6 w-6 hover:text-yellow" })
                      ], 8, _hoisted_4)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      }, 8, ["noData"])
    ]),
    _: 1
  }))
}
}

})